<template>
  <v-form ref="form" flat class="pa-6">
    <autocomplete-major
      v-model="major"
      :defaultMajors="[major]"
      item-text="title"
      item-value="id"
      label="Chuyên Ngành"
      return-object
      required
      dense
      outlined
      :rules="[$rules.required]"
      @change="onMajorChange"
    ></autocomplete-major>
    <v-autocomplete
      :rules="[$rules.required]"
      v-model="course"
      item-text="title"
      :items="getCourseItems"
      return-object
      item-value="id"
      label="Môn học"
      required
      dense
      outlined
      @change="onCourseChange"
    ></v-autocomplete>
    <v-text-field
      :rules="[$rules.required]"
      v-model="tags"
      label="Nhóm"
      placeholder="Nhập tên nhóm "
      required
      outlined
      dense
    ></v-text-field>
    <v-text-field
      :rules="[$rules.required]"
      ref="code"
      v-model="code"
      label="Mã lớp"
      placeholder="Nhập mã lớp"
      required
      dense
      outlined
    ></v-text-field>
    <!-- disabled -->
    <!-- patern="XXXX-XX" -->
    <v-select
      v-model="room"
      :rules="[$rules.required]"
      item-text="title"
      item-value="id"
      :items="rooms"
      label="Phòng Học"
      placeholder="Chọn một phòng học"
      height="42"
      dense
      outlined
    ></v-select>
    <autocomplete-teacher
      v-model="teachers"
      :defaultTeachers="teachers"
      item-text="name"
      item-value="id"
      label="Giáo viên"
      deletable-chips
      chips
      small-chips
      multiple
      dense
      outlined
    ></autocomplete-teacher>
    <autocomplete-teacher
      v-model="mentors"
      item-text="name"
      item-value="id"
      label="Trợ Giảng"
      chips
      small-chips
      deletable-chips
      multiple
      dense
      outlined
    ></autocomplete-teacher>
    <v-select
      v-model="courseMarkConfig"
      item-text="title"
      item-value="id"
      :items="courseMarkConfigs"
      label="Cấu hình điểm"
      placeholder="Chọn cấu hình điểm"
      height="42"
      dense
      outlined
    ></v-select>

    <v-text-field
      v-model="facebook_group"
      label="Nhóm Facebook"
      placeholder="Nhập đường dẫn nhóm Facebook"
      outlined
      dense
      :rules="[$rules.url]"
    ></v-text-field>
    <v-text-field
      :rules="[$rules.url]"
      v-model="drive_link"
      label="Ổ Drive"
      placeholder="Nhập đường dẫn ổ Drive"
      outlined
      dense
    ></v-text-field>
    <!-- <autocomplete-teacher
      v-model="grading_teachers"
      item-text="name"
      item-value="id"
      label="Giáo viên chấm cuối môn"
      chips
      small-chips
      deletable-chips
      multiple
      dense
      outlined
    ></autocomplete-teacher> -->
    <v-textarea ref="description" v-model="description" label="Mô Tả" outlined></v-textarea>
  </v-form>
</template>
<script>
import { get } from 'lodash'
import AutocompleteTeacher from '@/components/basic/input/AutocompleteTeacher'
import AutocompleteMajor from '@/components/basic/input/AutocompleteMajor'
import TextFieldCode from '@/components/basic/input/TextFieldCode'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    AutocompleteTeacher,
    AutocompleteMajor,
    TextFieldCode
  },
  props: {
    classData: {
      type: [Object],
      required: true,
      default: () => {}
    },
    majorData: Object,
    courseData: Object
  },
  data: () => ({
    room: '',
    valid: true,
    course: '',
    major: '',
    startTime: '',
    endTime: '',
    code: '',
    tags: '',
    description: '',
    teachers: [],
    mentors: [],
    courseMarkConfig: '',
    // grading_teachers: [],
    staff: {},
    facebook_group: '',
    drive_link: ''
  }),
  computed: {
    ...mapGetters('rooms', ['rooms']),
    ...mapGetters('course', ['courses']),
    getCourseItems() {
      if (!this.major) {
        return []
      }
      const output = this.courses.filter(c =>
        this.major.courses.find(x => x === c.id || x.id === c.id)
      )
      return output
    },
    courseMarkConfigs() {
      if (!this.courses || !this.course) {
        return []
      }
      const course = this.courses.find(c => c.id === this.course.id)
      if (!course) {
        return []
      }
      return course.course_mark_configs
    },
    selectedCourseId() {
      return (this.course || {}).id
    },
    selectedMajorId() {
      return (this.major || {}).id
    }
  },
  methods: {
    ...mapActions('rooms', ['fetchRooms']),
    ...mapActions('course', ['fetchCourses']),
    onMajorChange() {
      this.course = null
      this.courseMarkConfig = null
    },
    onCourseChange() {
      this.courseMarkConfig = null
    },

    getCourseFilter() {
      return { major: get(this.major, 'id', null) }
    },
    resetDefault() {
      if (this.classData) {
        this.teachers = this.classData.teachers
        this.mentors = this.classData.mentors
        this.courseMarkConfig = get(this.classData, 'course_mark_config.id', '')
        // this.grading_teachers = this.classData.grading_teachers
        this.code = this.classData.code
        this.room = this.classData.room
        this.tags = this.classData.tags
        this.course = this.courseData || this.classData.course
        this.major = this.majorData || this.classData.major
        this.startTime = this.classData.startTime
        this.description = this.classData.description
        this.drive_link = this.classData.drive_link
        this.facebook_group = this.classData.facebook_group
        this.endTime = this.classData.endTime
        this.staff = get(this.classData, 'staff.id', null)
      } else {
        this.teachers = []
        this.mentors = []
        this.courseMarkConfig = ''
        this.code = ''
        this.room = ''
        this.tags = ''
        this.course = null
        this.major = null
        this.startTime = ''
        this.description = ''
        this.endTime = ''
        this.staff = ''
      }
    },
    getData() {
      if (this.$refs.form.validate()) {
        return {
          // grading_teachers: this.grading_teachers,
          teachers: this.teachers,
          description: !this.description ? null : this.description,
          code: this.code,
          room: this.room,
          tags: this.tags,
          mentors: this.mentors,
          course_mark_config: this.courseMarkConfig,
          course: this.course,
          major: this.major,
          drive_link: this.drive_link || null,
          facebook_group: this.facebook_group || null
        }
      }
    }
  },
  created() {
    this.resetDefault()
    this.fetchRooms({ department: this.classData.department.id })
    this.fetchCourses()
  },
  watch: {
    classData(v) {
      // this.resetDefault()
      if (v) {
        this.fetchCourse(v.course.id)
      }
    }
  }
}
</script>

<style scoped></style>
